import { type Chain } from "viem"
import { optimism } from "viem/chains"
import cx from "classnames"

import ChainCurrency from "./ChainCurrency"
import { type ChainConfig, isArbitrumSXChain } from "./helper"

const ChainButton = ({
  chain,
  isActive,
  onClick,
}: {
  chain: Chain & ChainConfig
  isActive: boolean
  onClick: (chain: Chain & ChainConfig) => void
}) => {
  return (
    <button
      className={cx(
        "flex items-center justify-between p-2 cursor-pointer bg-accent-grey-800 first-of-type:rounded-t-sm last-of-type:rounded-b-sm w-full"
      )}
      onClick={e => {
        e.stopPropagation()
        onClick(chain)
      }}
    >
      <div className="flex items-center">
        <ChainCurrency
          chainId={chain.id as any}
          chainClassName="border-accent-grey-800"
          className="mr-2"
          size={4}
          currencyIcon={chain.betTokenIcon}
        />
        <div className="text-caption-12">
          {chain.id === optimism.id ? "Optimism" : chain.name} {chain.currency}{" "}
          {isArbitrumSXChain(chain) && "SX"}
        </div>
      </div>
      <div
        className={cx(
          "size-4 border flex items-center justify-center rounded-full",
          {
            "border-accent-grey-700": !isActive,
            "border-brand-light-500": isActive,
          }
        )}
      >
        {isActive && <div className="size-3 bg-brand-light-500 rounded-full" />}
      </div>
    </button>
  )
}

export default ChainButton
